import store from '../store';
let winPrint = null;

export default {
  ID() {
    return '_' + Math.random().toString(36).substr(2, 9);
  },

  focusElement(id, mobile, preventScroll) {
    if (!store.state.is_mobile || mobile) {
      const el = document.getElementById(id);

      setTimeout(function () {
        if (el) {
          el.focus({ preventScroll });
        }
      }, 100);
    }
  },

  selectElement(id) {
    const el = document.getElementById(id);
    setTimeout(function () {
      if (el) {
        el.select();
      }
    }, 100);
  },

  parseJSONObject(jsonString){
    try {
      const o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        return o;
      }
    }
    catch (e) { }
    return null;
  },

  toggleModal(n, id, callback) {
    if (n) {
      document.getElementById('body').classList.add('modal-open');

      if (id) {
        const el = document.getElementById(id);
        if (el) {
          el.focus();
          el.addEventListener('keyup', (e) => {
            if (e.key === 'Escape' && callback) {
              callback(false);
            }
          });
        }
      }

    } else {
      document.getElementById('body').classList.remove('modal-open');
    }
  },

  confirmarSenhaAdm(vue, callback, dados) {
    if (!vue.$store.state.dataUser.admin && vue.$store.state.pdv.senha_pdv) {
      vue.$swal({
        text: 'Por favor solicite ao responsável a liberação',
        content: {
          element: "input",
          attributes: {
            placeholder: "Informe a senha",
            type: "text",
            className: 'form-control inputAdm'
          }
        },
        buttons: ['Voltar','Enviar'],
      }).then(senha => {
        if (senha) {
          setTimeout(() => {
            if (senha === vue.$store.state.pdv.senha_pdv) {
              callback(dados);

            } else {
              vue.$swal("", "A senha está incorreta!");
            }
          }, 250);
        }
      });

    } else {
      callback(dados);
    }
  },

  imprimirPedido(vue, id_pedido, token, elPedido, cozinhas, printCopies, callback) {
    if (!id_pedido) {
      return;
    }

    const cf = vue.$store.state.impressora;
    const html = document.getElementById(elPedido);

    if (html) {
      const dataPedidos = [];
      const contentPedido = {
        content: html.innerHTML,
        copies: 1,
        isPdv: true,
        status: 1,
        nome_documento: 'Pedido PDV: ' + id_pedido,
        device: cf.device || null
      };

      if (cozinhas && cozinhas.length) {
        cozinhas.forEach(c => {
          dataPedidos.push({ ...contentPedido,
            device: c.device || null,
            id_cozinha: c.id_cozinha || null,
          });
        });

      } else {
        contentPedido.copies = printCopies ? parseInt(printCopies) : 1;
        dataPedidos.push(contentPedido);
      }

      dataPedidos.forEach(data => {
        data.impressora = {
          device: data.device || null,
          id_cozinha: data.id_cozinha || null,
          zoom: cf.zoom || "9px",
          largura: cf.largura || '100%'
        };
      });

      this.imprimir(vue, token, dataPedidos, cf.mobilePrint);
    }

    if (callback) {
      callback();
    }
  },

  imprimir(vue, token, dataImpressao, mobilePrint) {
    if (vue.isElectron && vue.$store.state.printLocal) {
      document.dispatchEvent(new CustomEvent('print', { detail: dataImpressao }));

    } else if (mobilePrint) {
      this.popUpimpressao(dataImpressao[0].content);

    } else {
      this.enviarImpressao(vue, token, dataImpressao);
    }
  },

  registrarFalhaImpressaoPedido(vue, pedido, resposta, solicitada) {
    if (!solicitada || resposta.id_impressao) {
      return;
    }

    const numero = pedido.id_contador || pedido.id_pedido;
    const motivo = resposta.erro_impressao || 'Não foi possível enviar o pedido para a fila de impressão.';
    vue.$store.commit('addOcorrencia', {
      titulo: `Falha na impressão — Pedido #${numero}`,
      tipo: '3',
      texto_informe: `O pedido foi aceito, mas não foi enviado para a fila de impressão. ${motivo} Reimprima o pedido manualmente.`
    });
  },

  imprimirComprovante(vue, token, dataImpressao, mobilePrint) {
    if (Number(vue.$store.state.configImpressao.migrado_legado || 0) !== 1) {
      return this.imprimir(vue, token, dataImpressao, mobilePrint);
    }

    dataImpressao = dataImpressao.map(documento => ({
      ...documento,
      content: /<html(?:\s|>)/i.test(documento.content)
        ? documento.content
        : `<!DOCTYPE html>
            <html>
            <head>
              <meta charset="UTF-8">
              <style>
                html, body { margin: 0; padding: 0; color: #000; font-family: sans-serif; font-size: 13px; }
                .right, .float-right { float: right; }
                .text-center { text-align: center; }
                .text-right { text-align: right; }
                .mb-1 { margin-bottom: 6px; }
              </style>
            </head>
            <body>${documento.content}</body>
           </html>`
    }));

    const local = vue.$store.state.impressoraComprovanteLocal;
    const config = vue.$store.state.configImpressao;
    const usarLocal = vue.isElectron && !vue.$store.state.printServer && local.modo === 'local';

    if (!vue.isElectron && Number(config.mobile_print || 0) === 1) {
      vue.$store.state.load = false;
      this.popUpimpressao(dataImpressao.map(documento => documento.content).join(''));
      return;
    }

    if (!usarLocal && (!config.id_impressora_comprovante || !config.impressora_comprovante_device)) {
      vue.$store.state.load = false;
      vue.$swal('Configure a impressora de comprovante na nova estrutura de impressão.');
      return;
    }

    const impressora = usarLocal ? {
      device: local.device || null,
      largura: Number(local.tamanho_bobina_mm || 70),
      zoom: Number(local.fonte_tamanho || 13)
    } : {
      id_impressora: config.id_impressora_comprovante,
      device: config.impressora_comprovante_device,
      largura: Number(config.impressora_comprovante_bobina || 80),
      zoom: Number(config.impressora_comprovante_fonte || 9)
    };

    const documentos = dataImpressao.map(documento => ({
      ...documento,
      usar_fonte_local: true,
      device: impressora.device,
      impressora: {
        ...impressora,
        zoom: Number(documento.fonte_fixa || impressora.zoom)
      }
    }));

    if (vue.isElectron && (vue.$store.state.printServer || usarLocal)) {
      vue.$store.state.load = false;
      document.dispatchEvent(new CustomEvent('printV2', { detail: documentos }));
      return;
    }

    return this.enviarImpressao(vue, token, documentos);
  },

  popUpimpressao(content) {
    const y = window.top.outerHeight / 2 + window.top.screenY - ( 1000 / 2);
    const x = window.top.outerWidth / 2 + window.top.screenX - ( 1000 / 2);

    if (winPrint) {
      winPrint.close();
    }

    winPrint = window.open('','', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=600, height=600, top=${y}, left=${x}`);

    if (winPrint) {
      winPrint.focus();
      winPrint.document.write(`<html><head><title>Impressão PDV</title><style>body{font-family:sans-serif;}.mb-1{margin-bottom:6px}.right,.float-right{float:right;}.text-center{text-align:center;}</style></head><body>${content}</body></html>`);

      setTimeout(() => {
        winPrint.print();
      }, 500);
    }
  },

  enviarImpressao(vue, token, dataImpressao) {
    vue.$store.state.load = "Enviando, aguarde..";
    vue.$http.post('pdv/impressao/' + localStorage.getItem('key'), { dataPedidos: dataImpressao })
      .then(res => {
        if (res.data && res.data.id_impressao) {
          vue.$socket.emit('print', {token, content: { id_impressao: res.data.id_impressao } });
          vue.$store.state.load = false;
          if (Number(vue.$store.state.configImpressao.migrado_legado || 0) === 1) {
            if (!vue.$store.state.printServer) {
              const ids = res.data.ids_impressao?.length ? res.data.ids_impressao : [res.data.id_impressao];
              vue.$store.commit('acompanharImpressaoRemota', ids);
            }
          } else {
            this.awaitImpressao(vue, res.data.id_impressao, 10000, 1);
          }
          vue.$swal('Impressão enviada para o servidor de impressão!');

        } else {
          vue.$store.state.load = false;
          vue.$swal("Não foi possível enviar para impressão, erro no servidor!");
        }

      }, res => {
        vue.$store.state.load = false;
        vue.$swal(res.data.msg ? res.data.msg : "Erro temporário");
      });
  },

  awaitImpressao(vue, id_impressao, tempo, tentativa = 1) {
    setTimeout(() => {
      vue.$http.get('pdv/impressao/' + id_impressao)
        .then(res => {
          if (res.data) {
            if (['2','3'].includes(res.data.status)) {
              vue.$store.state.load = false;
              vue.$store.state.printsError = 0;

              if (tentativa > 1) {
                vue.$swal('Ok!', 'Enviado para impressão');
              }

            } else if (tentativa === 1) {
              this.awaitImpressao(vue, id_impressao, 10000, 2);

            } else {
              const err = res.data.status === '1' ? 'Verifique o servidor de impressão.' : 'Confira o erro no servidor de impressão.';
              vue.$store.state.load = false;
              vue.$store.state.printsError = 1;
              vue.$swal({
                text: "Não conseguimos imprimir\n" + err,
                buttons: ["Fechar", "Reenviar"]
              }).then((res) => {
                if (res) {
                  vue.$store.state.load = "Enviando, aguarde..";
                  this.awaitImpressao(vue, id_impressao, 8000, tentativa + 1);
                }
              });
            }
          }

        }, res => {
          vue.$store.state.load = false;
          vue.$swal(res.data.msg ? res.data.msg : "Erro temporário. Consultar Impressão");
        });
    }, tempo)
  },

  async imprimirUrl(vue, url, empresa, titulo, tipo = 'html') {
    const cf = vue.$store.state.impressora;

    if (!vue.isElectron && cf.mobilePrint && Number(vue.$store.state.configImpressao.migrado_legado || 0) !== 1) {
      const pars = `imprimir=true&largura=${cf.largura || '100%'}&zoom=${ cf.zoom || "9px"}`;
      const y = window.top.outerHeight / 2 + window.top.screenY - ( 1000 / 2);
      const x = window.top.outerWidth / 2 + window.top.screenX - ( 1000 / 2);

      if (winPrint) {
        winPrint.close();
      }

      this.openArquivo(vue, url + pars, tipo, (fileUrl) => {
        if (fileUrl) {
          winPrint = window.open(fileUrl, "", `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=600, height=600, top=${y}, left=${x}`);

          if (winPrint) {
            winPrint.focus();
          }
        }
      });

    } else {
      vue.$store.state.load = "Gerando documento..";
      vue.$http.get(url).then((res) => {
        vue.$store.state.load = false;

        if (res.body) {
          const device = cf.devicePdv || null;
          const dataImpressao = {
            content: res.body,
            copies: 1,
            isPdv: true,
            status: 1,
            nome_documento: titulo,
            device,
            impressora: {
              device,
              zoom: cf.zoom || "9px",
              largura: cf.largura || '100%'
            }
          };

          this.imprimirComprovante(vue, empresa, [dataImpressao]);
        }

      }, () => {
        vue.$store.state.load = false;
      });
    }
  },

  scrollTop(id) {
    const modal = document.getElementById(id);
    if (modal) {
      modal.scrollTop = 0
    }
  },

  scrollToView(id) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  },

  getTipoComanda(comanda) {
    if (comanda) {
      switch (parseInt(comanda.tipo_comanda)) {
        case 1:
          return "MESA: " + comanda.mesa;

        case 2:
          return "DELIVERY";

        case 3:
          return "COMANDA: " + comanda.ref_comanda;

        case 4:
          return "VENDA RÁPIDA";

        case 5:
          return "BALCÃO";
      }
    }
  },

  getLink(page) {
    return window.location.href.replace(/#\/.*/, `#/${page || ''}`)
  },

  openArquivo(vue, url, tipo = 'html', callback) {
    vue.$store.state.load = true;

    if (vue.isElectron) {
      document.dispatchEvent(new CustomEvent('goPageExternal', { detail: { url, x_auth: vue.$store.state.x_auth, tipo }}));

      setTimeout(() => {
        vue.$store.state.load = false;
      }, 1000);

      return;
    }

    const mimeTypes = {
      pdf: 'application/pdf',
      csv: 'text/csv',
      html: 'text/html',
      txt: 'text/plain',
      xml: 'application/xml',
      json: 'application/json',
    };

    const mimeType = mimeTypes[tipo] || 'application/octet-stream';

    vue.$http.get(url, { responseType: 'blob' })
      .then(response => {
        vue.$store.state.load = false;
        const blob = new Blob([response.body], { type: mimeType });
        const fileUrl = window.URL.createObjectURL(blob);

        if (callback) {
          callback(fileUrl);

        } else {
          window.open(fileUrl, '_blank');
        }

      }, error => {
        vue.$store.state.load = false;
        vue.$swal('Erro ao baixar o arquivo');
        console.error('Erro ao baixar o arquivo:', error);

        if (callback) callback(null);
      });
  },

  getUrlPortal() {
    let isHomolog = window.location.href.startsWith('https://hhh.');
    let isBeta = window.location.href.startsWith('https://beta.');
    return isHomolog ? "https://hhh.portal.lecard.delivery/" : (isBeta ? "https://beta.portal.lecard.delivery/" : "https://portal.lecard.app/");
  }
};
